import {
  AfterContentChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { constants } from 'src/app/constants';
import { ServicehotelExtendsComponent } from 'src/app/config/servicehotel/servicehotel-extends/servicehotel-extends.component';
import { ClientService } from 'src/app/api/sale/client.service';
import { UbigeoService } from 'src/app/api/config/ubigeo.service';
import { HttpHeaders } from '@angular/common/http';
declare var $: any;

@Component({
  selector: 'app-client-form',
  templateUrl: './client-form.component.html',
  styleUrls: ['./client-form.component.css']
})
export class ClientFormComponent implements OnInit, AfterContentChecked {
  branchofficeSlug: string = '';
  nameMenu: string = 'information_general';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  save_add: boolean = false;

  required_ubigeo: boolean = false;

  // set values variables
  typeClientNatural: any = constants.CLIENT.TYPE[0];
  documentDni: any = constants.CLIENT.TYPE_DOCUMENT.DNI;
  documentRuc: any = constants.CLIENT.TYPE_DOCUMENT.RUC;

  typeDocumentSelected: any = null;
  departmentSelected: any = 0;
  provinceSelected: any = null;
  ubigeoEdit: any = null;
  imageUrl: any = null;
  fileUrlImage: any = null;

  typesclient: any = [];
  typesdocument: any = [];
  statusmarital: any = [];
  sexs: any = [];

  // ubigeo data
  departments: any = [];
  provinces: any = [];
  districts: any = [];

  service_alert:any = {
    class : "success",
    message:"",
    show: false,
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private alertifyMsg: AlertifyHelper,
    private globalService: GlobalService,
    private clientService: ClientService,
    private generalService: GeneralService,
    private ubigeoService: UbigeoService,
    public toolsService: ToolsService,
    private changeDetector: ChangeDetectorRef,

    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      document: ['', [Validators.required]],
      fullname: ['', [Validators.required, Validators.minLength(2)]],
      type_client: [this.typeClientNatural.id, [Validators.required]],
      typedocument_id: [this.documentDni.id, [Validators.required]],
      tradename: [null],
      ubigeo: [null],
      address: [null],
      cellphone: [null],
      telephone: [null],
      email: [null, [Validators.email]],
      date_birthday: [null],
      status: [null],
      sex: [null],
      url_image: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    // set initial values ============
    this.getTypeClient();
    this.getStatusMarital();
    this.getSexs();
    this.getTypeDocument();
    this.getDepartments();

    if (this.isEdit) {
      this.editData();
    }

    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  editData() {
    this.clientService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          document: _item.document,
          fullname: _item.fullname,
          type_client: _item.type_client.split(' ').join(''),
          typedocument_id: _item.typedocument_id,
          tradename: _item.tradename,
          ubigeo: _item.ubigeo,
          address: _item.address,
          cellphone: _item.cellphone,
          telephone: _item.telephone,
          email: _item.email,
          date_birthday: _item.date_birthday,
          status: _item.status,
          sex: _item.sex,
          url_image: _item.url_image
        });

        this.checkUbigeo();
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  // FUNCTIONS LOADS DATAS

  getTypeClient() {
    this.generalService.listTypeClient().subscribe({
      next: (data: any) => {
        this.typesclient = data;
      }
    });
  }

  getStatusMarital() {
    this.generalService.listStatusMarital().subscribe({
      next: (data: any) => {
        this.statusmarital = data;
      }
    });
  }

  getSexs() {
    this.generalService.listSexs().subscribe({
      next: (data: any) => {
        this.sexs = data;
      }
    });
  }

  getTypeDocument() {
    this.generalService.listTypeDocument().subscribe({
      next: (data: any) => {
        this.typesdocument = data;
        this.changeTypeDocument();
      }
    });
  }

  getDepartments() {
    this.ubigeoService.departments().subscribe({
      next: (data: any) => {
        this.departments = data.results;
      }
    });
  }

  getProvinces(department_code: any) {
    this.ubigeoService.provinces(department_code).subscribe({
      next: (data: any) => {
        this.provinces = data.results;
        this.provinceSelected = null;
        this.required_ubigeo = true;
        if (this.ubigeoEdit != null) {
          this.provinceSelected = this.ubigeoEdit.substr(0, 4);
        }
      }
    });
  }

  getDistricts(department_code: any) {
    this.ubigeoService.districts(department_code).subscribe({
      next: (data: any) => {
        this.districts = data.results;
        this.item.patchValue({
          ubigeo: null
        });

        if (this.ubigeoEdit != null) {
          this.item.patchValue({
            ubigeo: this.ubigeoEdit
          });
        }
      }
    });
  }

  changeTypeDocument() {
    this.typeDocumentSelected = this.toolsService.searchArrById(
      this.item.value.typedocument_id,
      this.typesdocument
    );
    // this.item.patchValue({
    //   document: null
    // });
  }

  changeDepartment() {
    this.provinceSelected = null;
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    this.provinces = [];
    this.districts = [];
    if (this.departmentSelected != 0) {
      this.getProvinces(this.departmentSelected);
    }
  }

  changeProvince() {
    this.districts = [];
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    if (this.toolsService.strToNull(this.provinceSelected) != null) {
      this.getDistricts(this.provinceSelected);
    }
  }

  checkUbigeo() {
    let ubigeo = this.item.value.ubigeo;
    if (ubigeo != null) {
      this.ubigeoEdit = ubigeo;
      this.required_ubigeo = true;
      this.departmentSelected = ubigeo.substr(0, 2);
      this.getProvinces(this.departmentSelected);
      this.getDistricts(ubigeo.substr(0, 4));
    }
  }

  extractRuc() {
    let param_ = this.item.value.document;
    if (param_ != null) {
      this.generalService.extractRuc(param_).subscribe({
        next: (data: any) => {
          if(data.success){
            this.replaceExtractDataRuc(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          }else{
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  extractDni() {
    let param_ = this.item.value.document;
    if (!_.isEmpty(param_)) {
      this.generalService.extractDni(param_).subscribe({
        next: (data: any) => {
          if(data.success){
            this.replaceExtractDataDni(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          }else{
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataDni(data: any) {
    this.item.patchValue({
      fullname: data.fullname,
      address: data.address
    });
  }

  replaceExtractDataRuc(data: any) {
    this.item.patchValue({
      fullname: data.name,
      address: data.address
    });

    this.service_alert.class = data.alert_status;
    this.service_alert.message = "El cliente se encuentra con estado "+data.status +" y en condición " +data.condition;
    this.service_alert.show = true;

    if(data.district_id != ""){
      this.item.patchValue({
        ubigeo: data.district_id,
      });
      this.checkUbigeo();
    }
    
  }


  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onSubmit() {
    this.submitted = true;
    this.item.patchValue({
      fullname: this.item.value.fullname.toUpperCase()
    });

    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    if (this.validate()) {
      data.item = this.item.value;

      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');

      formData.append('item', JSON.stringify(data));
      formData.append('url_image', this.fileUrlImage);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.clientService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/ventas/clientes/lista'
            ]);
          }
        });
      } else {
        this.clientService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.router.navigate([
              this.branchofficeSlug + '/ventas/clientes/lista'
            ]);
          }
        });
      }
    }
  }

  validate() {
    let item_ = this.item.value;
    if(item_.typedocument_id == this.documentDni.id){
      if(item_.document.length < this.documentDni.max_length){
        this.alertifyMsg.warning('El DNI ingresado debe tener 8 dígitos.');
        (<any>$('#client_document')).focus();
        return false;
      }
    }

    if(item_.typedocument_id == this.documentRuc.id){
      if(item_.document.length < this.documentRuc.max_length){
        this.alertifyMsg.warning('El RUC ingresado debe tener 11 dígitos.');
        (<any>$('#client_document')).focus();
        return false;
      }
    }
    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    (<any>$('#item_description')).focus();
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/ventas/clientes/lista']);
  }
}
